import { buildModelManager } from "../builder.js";
const DefaultContactSelection = {
  __typename: true,
  id: true,
  attributedUserId: true,
  birthday: true,
  createdAt: true,
  customProperties: true,
  customerId: true,
  d_dpuuid: true,
  externalId: true,
  firstName: true,
  hasOptIn: true,
  hashedFirstName: true,
  hashedLastName: true,
  hashedPhoneNumber: true,
  hashedWhatsappName: true,
  invalidWhatsAppUserAt: true,
  isCheckoutOptin: true,
  isEncrypted: true,
  isInvalidWhatsAppUser: true,
  isKlaviyoOptin: true,
  klaviyoFirstName: true,
  klaviyoLastName: true,
  lastName: true,
  oldFirstName: true,
  oldLastName: true,
  oldPhoneNumber: true,
  oldWhatsappName: true,
  optInSourceId: true,
  optinAt: true,
  optoutAt: true,
  optoutScenarioId: true,
  shopifyCustomerId: true,
  updatedAt: true,
  userPhoneNumber: true,
  whatsappName: true
};
const modelApiIdentifier = "contact";
const pluralModelApiIdentifier = "contacts";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByUserPhoneNumber",
    findByField: "userPhoneNumber",
    findByVariableName: "userPhoneNumber",
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByUserPhoneNumber",
    findByField: "userPhoneNumber",
    findByVariableName: "userPhoneNumber",
    modelApiIdentifier,
    defaultSelection: DefaultContactSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createContact",
    operationReturnType: "CreateContact",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { contact: { required: false, type: "CreateContactInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultContactSelection
  },
  {
    type: "action",
    operationName: "bulkCreateContacts",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateContactsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultContactSelection
  },
  {
    type: "action",
    operationName: "updateContact",
    operationReturnType: "UpdateContact",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      contact: { required: false, type: "UpdateContactInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultContactSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateContacts",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateContactsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultContactSelection
  },
  {
    type: "action",
    operationName: "deleteContact",
    operationReturnType: "DeleteContact",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteContacts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertContact",
    operationReturnType: "UpsertContact",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      contact: { required: false, type: "UpsertContactInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateContactResult": { hasReturnType: false },
      "... on UpdateContactResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultContactSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertContacts",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertContactsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultContactSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "contactGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ContactManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultContactSelection,
  operations
);
export {
  ContactManager,
  DefaultContactSelection
};
//# sourceMappingURL=Contact.js.map
